/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PageDataGetUserWalletDetailPageListRespVo } from './PageDataGetUserWalletDetailPageListRespVo';
import {
    PageDataGetUserWalletDetailPageListRespVoFromJSON,
    PageDataGetUserWalletDetailPageListRespVoFromJSONTyped,
    PageDataGetUserWalletDetailPageListRespVoToJSON,
    PageDataGetUserWalletDetailPageListRespVoToJSONTyped,
} from './PageDataGetUserWalletDetailPageListRespVo';

/**
 * 
 * @export
 * @interface ResponsePageDataGetUserWalletDetailPageListRespVo
 */
export interface ResponsePageDataGetUserWalletDetailPageListRespVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponsePageDataGetUserWalletDetailPageListRespVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponsePageDataGetUserWalletDetailPageListRespVo
     */
    message?: string;
    /**
     * 
     * @type {PageDataGetUserWalletDetailPageListRespVo}
     * @memberof ResponsePageDataGetUserWalletDetailPageListRespVo
     */
    data?: PageDataGetUserWalletDetailPageListRespVo;
}

/**
 * Check if a given object implements the ResponsePageDataGetUserWalletDetailPageListRespVo interface.
 */
export function instanceOfResponsePageDataGetUserWalletDetailPageListRespVo(value: object): value is ResponsePageDataGetUserWalletDetailPageListRespVo {
    return true;
}

export function ResponsePageDataGetUserWalletDetailPageListRespVoFromJSON(json: any): ResponsePageDataGetUserWalletDetailPageListRespVo {
    return ResponsePageDataGetUserWalletDetailPageListRespVoFromJSONTyped(json, false);
}

export function ResponsePageDataGetUserWalletDetailPageListRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponsePageDataGetUserWalletDetailPageListRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : PageDataGetUserWalletDetailPageListRespVoFromJSON(json['data']),
    };
}

export function ResponsePageDataGetUserWalletDetailPageListRespVoToJSON(json: any): ResponsePageDataGetUserWalletDetailPageListRespVo {
    return ResponsePageDataGetUserWalletDetailPageListRespVoToJSONTyped(json, false);
}

export function ResponsePageDataGetUserWalletDetailPageListRespVoToJSONTyped(value?: ResponsePageDataGetUserWalletDetailPageListRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': PageDataGetUserWalletDetailPageListRespVoToJSON(value['data']),
    };
}

